import React from "react";


export function SectionAbout() {
  return(
    <div className="container">
      <h5> I'm ABOUT </h5>
    </div>
  )
}
